import { render } from "./Tanzania.vue?vue&type=template&id=6a025821"
import script from "./Tanzania.vue?vue&type=script&lang=js"
export * from "./Tanzania.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__